import { useParams } from "react-router";
import { useLocale } from "use-intl";
import { lt } from "@liftquest/shared/localized";
import { Page, PageHeader } from "@/components/app/page-header";
import { NotFound, PageLoading } from "@/components/app/states";
import { useExercises, usePlan } from "@/lib/queries";
import { WorkoutEditor } from "./workout-editor";

export function WorkoutPage() {
  const { planId = "", workoutId = "" } = useParams();
  const locale = useLocale();
  const plan = usePlan(planId);
  const exercises = useExercises();
  if (plan.isPending || exercises.isPending) return <PageLoading />;
  const workout = plan.data?.workouts.find((w) => w.id === workoutId);
  if (!plan.data || !workout) return <NotFound />;
  const library = (exercises.data ?? [])
    .map((e) => ({ id: e.id, name: lt(e.name, locale), type: e.type, muscles: e.muscles }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));

  return (
    <Page>
      <PageHeader backHref={`/plans/${planId}`} title={lt(workout.name, locale)} subtitle={lt(plan.data.name, locale)} />
      <WorkoutEditor
        planId={planId}
        workout={{ id: workout.id, name: workout.name, focus: workout.focus, kind: workout.kind }}
        items={workout.exercises.map((we) => ({
          id: we.id,
          exerciseId: we.exerciseId,
          name: lt(we.exercise.name, locale),
          type: we.exercise.type,
          sets: we.sets,
          targetMin: we.targetMin,
          targetMax: we.targetMax,
          restSec: we.restSec,
          warmupSets: we.warmupSets,
          alternativeExerciseId: we.alternativeExerciseId,
          alternativeNote: we.alternativeNote,
          notes: we.notes,
        }))}
        library={library}
      />
    </Page>
  );
}
